import {ASSESSMENT_MANDATORY_CONFIG} from '../../../util/patientContextUtil';

export const DEFAULT_PATIENT_VALUE = {
    demographicPosition: 'right',
};

export const DEFAULT_REGISTRATION_VALUE = {
    feedback: true,
};

export const DEFAULT_LOCATION_VALUE_CLEANING_REQUEST = {
    ED: {
        enabled: true,
        auto: false,
    },
    IP: {
        enabled: true,
        auto: false,
    },
};

export const DEFAULT_LEVEL_VALUE_CLEANING_REQUEST = {
    level1: 60,
    level2: 120,
    level3: 420,
};

export const DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST = {
    discharge: true,
    transfer: true,
    offWard: true,
};

export const DEFAULT_OBS_CFG_VALUE = {
    retrospective: false,
};

export const DEFAULT_ASSESSMENTS_VALUE = {
    mandatory: {
        enabled: false,
        showBorderline: ASSESSMENT_MANDATORY_CONFIG.DONT_SHOW_BORDERLINE,
        modalDisplay: ASSESSMENT_MANDATORY_CONFIG.DONT_DISPLAY_MODAL_ON_DISCHARGE,
    },
    ED: {
        mandatory: [],
        suggested: [],
    },
    SDEC: {
        mandatory: [],
        suggested: [],
    },
    EDAU: {
        mandatory: [],
        suggested: [],
    },
    INPATIENT: {
        mandatory: [],
        suggested: [],
    },
};